/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

/**
 * Exports
*/

/**
 * 
 */
export function Router(props) {
  /** Contexts **/
  
  const match = useRouteMatch();
  
  /** Output **/

  return (
    <props.provider>
      <Switch>
        {
          props.routes.map((route, index) => (
            <Route
              key={ index }
              component={ route.component }
              path={ `${ match.path }${ route.path || '' }` }
            />
          ))
        }
      </Switch>
    </props.provider>
  );
}

Router.propTypes = {
  provider: PropTypes.func.isRequired,
  routes: PropTypes.array.isRequired
};